"use strict";

exports.__esModule = true;
exports.MockParams = void 0;
exports.mockFeatureFormat = mockFeatureFormat;
exports.mockFeatureRetrieve = mockFeatureRetrieve;
exports.mockFormat = mockFormat;
exports.mockRetrieve = mockRetrieve;
exports.mockWinnersFormat = mockWinnersFormat;
exports.mockWinnersRetrieve = mockWinnersRetrieve;
var MockParams;
exports.MockParams = MockParams;

(function (MockParams) {
  MockParams["MOCK_TEST"] = "darwin_mock_test";
  MockParams["MOCK_FEATURE_ON"] = "darwin_mock_feature_on";
  MockParams["MOCK_FEATURE_OFF"] = "darwin_mock_feature_off";
  MockParams["MOCK_WINNER"] = "darwin_mock_winner";
})(MockParams || (exports.MockParams = MockParams = {}));

function mockFormat(tests, path) {
  if (path === void 0) {
    path = window.location.search;
  }

  var url = new URL("https://localhost.com" + path);
  url.searchParams.delete(MockParams.MOCK_TEST);
  tests.forEach(function (_ref) {
    var name = _ref.name,
        value = _ref.value;
    // Please lord, let people not use dunders in test names or values
    url.searchParams.append(MockParams.MOCK_TEST, name + "__" + value);
  });
  return url.search;
}

function mockRetrieve(path) {
  var url = new URL("https://localhost.com" + path);
  return Array.from(url.searchParams.getAll(MockParams.MOCK_TEST).map(function (pair) {
    return pair.split("__");
  }).map(function (_ref2) {
    var name = _ref2[0],
        value = _ref2[1];
    return {
      name: name,
      value: value
    };
  }));
}

function mockFeatureFormat(features, path) {
  if (path === void 0) {
    path = window.location.search;
  }

  var url = new URL("https://localhost.com" + path);
  url.searchParams.delete(MockParams.MOCK_FEATURE_ON);
  url.searchParams.delete(MockParams.MOCK_FEATURE_OFF);
  Object.entries(features).forEach(function (_ref3) {
    var name = _ref3[0],
        on = _ref3[1];

    if (on) {
      url.searchParams.append(MockParams.MOCK_FEATURE_ON, name);
    } else {
      url.searchParams.append(MockParams.MOCK_FEATURE_OFF, name);
    }
  });
  return url.search;
}

function mockFeatureRetrieve(path) {
  var url = new URL("https://localhost.com" + path);
  var res = {};
  url.searchParams.forEach(function (val, key) {
    if (key === MockParams.MOCK_FEATURE_ON) {
      // eslint-disable-next-line fp/no-mutation
      res[val] = true;
    }

    if (key === MockParams.MOCK_FEATURE_OFF) {
      // eslint-disable-next-line fp/no-mutation
      res[val] = false;
    }
  });
  return res;
}

function mockWinnersFormat(tests, path) {
  if (path === void 0) {
    path = window.location.search;
  }

  var url = new URL("https://localhost.com" + path);
  url.searchParams.delete(MockParams.MOCK_WINNER);
  tests.forEach(function (_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    // Please lord, let people not use dunders in test names or values
    url.searchParams.append(MockParams.MOCK_WINNER, name + "__" + value);
  });
  return url.search;
}

function mockWinnersRetrieve(path) {
  var url = new URL("https://localhost.com" + path);
  return Array.from(url.searchParams.getAll(MockParams.MOCK_WINNER).map(function (pair) {
    return pair.split("__");
  }).map(function (_ref5) {
    var name = _ref5[0],
        value = _ref5[1];
    return {
      name: name,
      value: value
    };
  }));
}